var _style, _polyline, _polyline2, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1930 255.5",
    style: {
      enableBackground: "new 0 0 1930 255.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n                  .st0 {\n                    fill: none;\n                    stroke: #3c3c3c;\n                    stroke-width: 10;\n                    stroke-linecap: square;\n                    stroke-miterlimit: 10;\n                  }\n                ")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1224,171.8 1181.3,171.8 1139.2,129.6 1065,203.9 970.5,110.4 876,203.6 801.8,129.4 759.7,171.5                                      717,171.5 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "5,131.5 757.3,131.5 801.8,176.1 885.9,91.9 868.3,74.2 831.5,111 870.4,149.9 970.2,50.2 1070,149.9                                      1108.8,111 1072.1,74.2 1054.4,91.9 1138.5,176.1 1183.1,131.5 1925,131.5 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 921.9,
    y: 26.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 231.426 707.2043)",
    className: "st0",
    width: 95,
    height: 95
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 921.9,
    y: 99.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 179.8072 728.5855)",
    className: "st0",
    width: 95,
    height: 95
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 940.3,
    y: 178.1,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 137.3893 746.1556)",
    className: "st0",
    width: 58.2,
    height: 58.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.9301ef59f3c4db3ce7b1bf816a3b237e.svg";
export { ForwardRef as ReactComponent };